// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7cdc1659","732":"9d2f0c1f","977":"43192cbb"}[chunkId] + ".chunk.js";
};